/* This file is auto-generated, manual edits in this file will be overwritten! */
const COLORS = {
    BG: { value: '#f8f9fc' },
    BGFullscreen: { value: '#E5E6ED' },
    Bancontact: {
        Blue: { value: '#005697' },
        Payconiq: { value: '#ff4785' },
        Yellow: { value: '#fbd500' },
    },
    Black: {
        T100: { value: '#cccccc' },
        T200: { value: '#999999' },
        T300: { value: '#666666' },
        T400: { value: '#333333' },
        T500: { value: '#000000' },
    },
    Blue: { value: '#1d4fff' },
    BrandColors: {
        Payment: {
            ApplePay: { value: '#f0edee' },
            GPay: { value: '#f3f3f3' },
        },
    },
    Chat: { value: '#eceef6' },
    CodeLine: { value: '#dbdde7' },
    Communication: {
        BG: { value: '#edeefc' },
        Stroke: { value: '#c2c6f4' },
        Text: { value: '#6772e5' },
    },
    Disabled: { value: '#f4f6fa' },
    DisabledIcon: { value: '#d2d5e0' },
    Edenred: {
        Red: { value: '#e60a14' },
    },
    Error: {
        T100: { value: '#fcdfdf' },
        T200: { value: '#fac0c0' },
        T300: { value: '#f8a1a1' },
        T400: { value: '#f68282' },
        T500: { value: '#f46363' },
        T600: { value: '#c34f4f' },
        T700: { value: '#923b3b' },
        T800: { value: '#612727' },
        T900: { value: '#301313' },
    },
    EventDetailBg: { value: '#e9eaef' },
    FilePreviewBg: { value: '#e7e9f4' },
    GorvnLogo: { value: '#7eb9cb' },
    Govrn: {
        Blue: {
            T50: { value: '#d7eaf866' },
            T100: { value: '#d7eaf8' },
            T200: { value: '#afd6f1' },
            T300: { value: '#88c1eb' },
            T400: { value: '#60ade4' },
            T500: { value: '#3999de' },
            T600: { value: '#2d7ab1' },
            T700: { value: '#225b85' },
            T800: { value: '#163d58' },
            T900: { value: '#0b1e2c' },
        },
        DarkBlue: {
            T100: { value: '#ccd5f8' },
            T200: { value: '#99abf2' },
            T300: { value: '#6681eb' },
            T400: { value: '#3357e5' },
            T500: { value: '#002ddf' },
            T600: { value: '#0024b2' },
            T700: { value: '#001b85' },
            T800: { value: '#001259' },
            T900: { value: '#00092c' },
        },
        Grey: {
            T100: { value: '#dee1e4' },
            T200: { value: '#bec3c9' },
            T300: { value: '#9ea5ae' },
            T400: { value: '#7e8793' },
            T500: { value: '#5e6a78' },
            T600: { value: '#4b5460' },
            T700: { value: '#383f48' },
            T800: { value: '#252a30' },
            T900: { value: '#121518' },
        },
        PastelGreen: {
            T100: { value: '#daefe9' },
            T200: { value: '#b5dfd3' },
            T300: { value: '#90cfbe' },
            T400: { value: '#6bbfa8' },
            T500: { value: '#46b093' },
            T600: { value: '#388c75' },
            T700: { value: '#2a6958' },
            T800: { value: '#1c463a' },
            T900: { value: '#0e231d' },
        },
        Pink: {
            T100: { value: '#f9d6f9' },
            T200: { value: '#f4aef3' },
            T300: { value: '#ee85ed' },
            T400: { value: '#e95de7' },
            T500: { value: '#e435e2' },
            T600: { value: '#b62ab4' },
            T700: { value: '#881f87' },
            T800: { value: '#5b155a' },
            T900: { value: '#2d0a2d' },
        },
        Purple: {
            T100: { value: '#ecdafd' },
            T200: { value: '#d9b6fc' },
            T300: { value: '#c692fa' },
            T400: { value: '#b36ef9' },
            T500: { value: '#a14af8' },
            T600: { value: '#803bc6' },
            T700: { value: '#602c94' },
            T800: { value: '#401d63' },
            T900: { value: '#200e31' },
        },
        Yellow: {
            T100: { value: '#fdf0ce' },
            T200: { value: '#fce19d' },
            T300: { value: '#fbd26c' },
            T400: { value: '#fac33b' },
            T500: { value: '#f9b50b' },
            T600: { value: '#c79008' },
            T700: { value: '#956c06' },
            T800: { value: '#634804' },
            T900: { value: '#312402' },
        },
    },
    HoverWelcome: { value: '#2f87c6' },
    IconsBg: { value: '#e7f3fb' },
    InputText: { value: '#8f95b2' },
    Line: { value: '#e7e9f4' },
    Maestro: {
        Blue: { value: '#0099df' },
        Purple: { value: '#6c6bbd' },
        Red: { value: '#eb001b' },
    },
    MasterCard: {
        Orange: { value: '#ff5f00' },
        Red: { value: '#eb001b' },
        Yellow: { value: '#f79e1b' },
    },
    Monizze: {
        Grey: { value: '#4f5d5b' },
        Orange: { value: '#f59100' },
    },
    NightbornBlue: { value: '#065aee' },
    Notification: { value: '#f14e4e' },
    PlaceholderBG: { value: '#e2e4f3' },
    ResetSearch: { value: '#dddee8' },
    SearchFullScreen: { value: '#eeeff4' },
    SelectedRowsSidebar: { value: '#edf2fe' },
    Social: {
        FacebookBlue: { value: '#1877f2' },
    },
    Sodexo: {
        Blue: { value: '#293896' },
        Red: { value: '#ed1c24' },
    },
    Stripe: {
        Purple: { value: '#6772e5' },
    },
    Stroke: { value: '#e9eaf0' },
    Success: {
        T100: { value: '#d5f6e3' },
        T200: { value: '#abedc8' },
        T300: { value: '#81e5ad' },
        T400: { value: '#57dc92' },
        T500: { value: '#2ed376' },
        T600: { value: '#24a95f' },
        T700: { value: '#1b7f47' },
        T800: { value: '#12542f' },
        T900: { value: '#092a17' },
    },
    Tag: { value: '#f2f4f9' },
    Tags: {
        Blue: { value: '#418bd4' },
        BlueGreen: { value: '#46b093' },
        BluePurple: { value: '#6949f8' },
        Brown: { value: '#6d190a' },
        DarkBlue: { value: '#002ddf' },
        DarkGrey: { value: '#5e6a78' },
        DarkOrange: { value: '#d3551b' },
        DarkPink: { value: '#ec4d76' },
        DarkPurple: { value: '#8853aa' },
        FlashBlue: { value: '#399ced' },
        FlashPruple: { value: '#e435e2' },
        Green: { value: '#54c16a' },
        Grey: { value: '#acb4ba' },
        LightBlue: { value: '#7da6fb' },
        LightBrown: { value: '#9f7531' },
        LightPink: { value: '#f07ea1' },
        LightPurple: { value: '#da7df6' },
        Orange: { value: '#f07623' },
        OrangeRed: { value: '#e93a22' },
        Purple: { value: '#aa55e3' },
        Turquoise: { value: '#42b0cc' },
        Yellow: { value: '#f4d534' },
        YellowOrange: { value: '#f9b50b' },
        PurpleRose: { value: '#AA55E3' },
        PurpleRoseBg: { value: '#E9D6F6' },
    },
    Text: {
        T100: { value: '#cdccd7' },
        T200: { value: '#9c99af' },
        T300: { value: '#6a6687' },
        T400: { value: '#39335f' },
        T500: { value: '#0B1F2C' },
        T600: { value: '#06002c' },
        T700: { value: '#040021' },
        T800: { value: '#030016' },
        T900: { value: '#01000b' },
    },
    Toast: {
        GreenBG: { value: '#eaf5ef' },
        RedBG: { value: '#f5eaea' },
    },
    ToastPurple: { value: '#6772e5' },
    ToastPurpleBG: { value: '#c2c6f4' },
    Visa: {
        Blue: { value: '#3362ab' },
        DarkBlue: { value: '#15195a' },
        Yellow: { value: '#f9b50b' },
    },
    Warning: {
        T100: { value: '#ffe9d7' },
        T200: { value: '#ffd3af' },
        T300: { value: '#ffbd87' },
        T400: { value: '#ffa75f' },
        T500: { value: '#ff9137' },
        T600: { value: '#cc742c' },
        T700: { value: '#995721' },
        T800: { value: '#663a16' },
        T900: { value: '#331d0b' },
    },
    White: {
        T500: { value: '#ffffff' },
        T600: { value: '#cccccc' },
        T700: { value: '#999999' },
        T800: { value: '#666666' },
        T900: { value: '#333333' },
    },
    BgPostSent: { value: '#edf0f7' },
    DarkGrey: { value: '#4D5E79' },
    DarkNavy: { value: '#203657' },
};
export default COLORS;
